<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div data-cy="fob-points-list">
    <div class="d-flex pt-3 mb-4 justify-content-between">
      <div style="display: flex; align-items: center">
        <h1>Fob Points</h1>
      </div>
      <div>
        <ValidateAllFobs v-if="!isLocal" />
        <router-link to="/admin/fob-points/create" class="btn btn-light" data-cy="fob-points-new">New Fob Point</router-link>
      </div>
    </div>
    <top-table
      :tabFilters="tabFilters"
      :columns="['fobId', 'supplierCode', 'country', 'state', 'city', 'zip', 'error', 'actions']"
      url="/fobPoints"
      ref="table"
      :overlap="true"
    >
      <template v-slot:actions="props">
        <div class="d-flex align-items-center">
          <router-link :to="`/admin/fob-points/${props.row._id}/edit`" class="btn btn-light mr-2">Edit</router-link>
          <div class="d-flex align-items-center">
            <DisableConditionsInfo :key="props.row._id" :conditions="conditions(props.row)" :btnClass="'w-100'">
              <ValidateFob :fob="props.row" @change="change" class="mr-2" />
            </DisableConditionsInfo>
          </div>

          <delete-button :title="props.row.fobId" :record="props.row" :remove="remove(props.row)" />
        </div>
      </template>
      <template v-slot:error="props">
        <PreviewRequest
          v-if="props.row.error"
          :key="props.row.updated"
          :details="{ response: formatXml(props.row.error.response) }"
        />
      </template>
    </top-table>
  </div>
</template>
<script>
const KEYS = ['country', 'state', 'city', 'zip'];
import { formatXml } from '../../../../utils/formatXML';
export default {
  name: 'FobPointsList',
  components: {
    DisableConditionsInfo: () => import('../../../../../libs/components/DisableConditionsInfo'),
    PreviewRequest: () => import('../../../../components/Grabber/PreviewRequest'),
    ValidateAllFobs: () => import('./ValidateAllFobs'),
    ValidateFob: () => import('./ValidateFob')
  },
  data() {
    return {
      isLocal: location.href.match(/localhost/),
      tabFilters: [
        { val: 'country', criteria: ['US', 'CA'] },
        { val: 'hasError', criteria: ['Yes', 'No'] }
      ]
    };
  },
  methods: {
    formatXml,
    conditions(item) {
      return KEYS.map((e) => ({
        valid: !!item[e],
        message: `Missing ${e}`
      }));
    },
    remove(row) {
      return () =>
        new Promise(async (resolve, reject) => {
          try {
            await this.$http.delete(`/fobPoints/${row._id}`);
            this.change();
            resolve();
          } catch (e) {
            reject(e);
          }
        });
    },
    change() {
      this.$refs.table.refresh();
    }
  }
};
</script>
